var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95628 13.4919H9.18705M12.264 6.10815V3.64689M6.72551 6.10815V1.80094H3.0332V6.10815M14.7255 2.1086C14.7255 2.31061 14.6857 2.51064 14.6084 2.69728C14.5311 2.88391 14.4178 3.05349 14.2749 3.19633C14.132 3.33918 13.9624 3.45249 13.7758 3.52979C13.5891 3.6071 13.3891 3.64689 13.187 3.64689H11.3409C10.9329 3.64689 10.5416 3.48482 10.253 3.19633C9.96452 2.90785 9.80243 2.51658 9.80243 2.1086C9.80243 1.70062 9.96452 1.30935 10.253 1.02087C10.5416 0.732382 10.9329 0.570313 11.3409 0.570312H13.187C13.3891 0.570312 13.5891 0.610102 13.7758 0.687408C13.9624 0.764714 14.132 0.878023 14.2749 1.02087C14.4178 1.16371 14.5311 1.33329 14.6084 1.51992C14.6857 1.70656 14.7255 1.90659 14.7255 2.1086Z",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3405 10.418H1.80206C1.12232 10.418 0.571289 10.9689 0.571289 11.6486V15.3405C0.571289 16.0201 1.12232 16.5711 1.80206 16.5711H15.3405C16.0203 16.5711 16.5713 16.0201 16.5713 15.3405V11.6486C16.5713 10.9689 16.0203 10.418 15.3405 10.418Z",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3402 10.4166V7.34001C15.3402 7.01362 15.2105 6.70061 14.9797 6.46982C14.7489 6.23903 14.4359 6.10938 14.1095 6.10938H3.03253C2.70611 6.10938 2.39306 6.23903 2.16224 6.46982C1.93143 6.70061 1.80176 7.01362 1.80176 7.34001V10.4166",
    stroke: "black",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailIcon);
export default __webpack_public_path__ + "static/media/retailIcon.62064cd7a4da7e77663b6940481fd538.svg";
export { ForwardRef as ReactComponent };